import { Compass } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-rule bg-obsidian py-14"
    >
      <div className="mx-auto grid max-w-7xl gap-8 px-6 md:grid-cols-12 md:px-10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="relative flex h-6 w-6 items-center justify-center border border-teal/70">
              <Compass className="h-3.5 w-3.5 text-teal" strokeWidth={1.5} />
              <span className="absolute -top-px -left-px h-1 w-1 bg-amber" />
            </span>
            <span className="font-display text-lg tracking-tight text-ink">
              Life OS
            </span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-mist">
            A quiet tower for household life. Situational awareness for the
            families the market forgot.
          </p>
        </div>

        <div className="md:col-span-7 md:justify-self-end">
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
                Product
              </p>
              <ul className="mt-4 space-y-3">
                {[
                  ["Modules", "/#modules"],
                  ["Signals", "/#signals"],
                  ["Principles", "/#principles"],
                  ["Sign in", "/login"],
                ].map(([label, href]) => (
                  <li key={label}>
                    <Link
                      to={href}
                      data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-ink transition-colors duration-300 hover:text-teal"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
                Company
              </p>
              <ul className="mt-4 space-y-3">
                {[
                  ["About", "/about"],
                  ["Manifesto", "/manifesto"],
                  ["Contact", "/contact"],
                ].map(([label, href]) => (
                  <li key={label}>
                    <Link
                      to={href}
                      data-testid={`footer-link-${label.toLowerCase()}`}
                      className="text-sm text-ink transition-colors duration-300 hover:text-teal"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
                Status
              </p>
              <div className="mt-4 flex items-center gap-2">
                <span className="h-1.5 w-1.5 bg-signalGreen animate-pulse-soft" />
                <span className="font-mono text-xs text-signalGreen">
                  Operational
                </span>
              </div>
              <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-mist">
                v0.1 · Private preview
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col items-start justify-between gap-3 border-t border-rule px-6 pt-6 md:flex-row md:items-center md:px-10">
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
          © {new Date().getFullYear()} Life OS · Made with care
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-mist">
          Bearing 034° · Altitude nominal · Fuel adequate
        </p>
      </div>
    </footer>
  );
}
